import React, { FC, useState } from "react";
import { Form, Input, Button, FormInstance, Select, notification } from "antd";
import { useNavigate } from "react-router-dom";

import CommonService from "../../services/common.service";
import { UserRoleTypes } from "../../services/enums";
import { formItemLayout } from "../../services/constants";
import { IUser } from "../../models/user.model";
import UserService from "../../services/user.service";
import { PrivateUIRoutes } from "../../router";

interface IProps {
  data: IUser;
  form: FormInstance;
}

const UserForm: FC<IProps> = ({ data, form }) => {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const create = async (values: IUser) => {
    setLoading(true);

    try {
      const response = await UserService.create(values);

      if (values.password) {
        try {
          await updatePassword(response.data.result.id, values.password);

          checkFinishHandler("created");
        } catch (errors: any) {
          checkErrorHandler(errors);
        }
      } else {
        checkFinishHandler("created");
      }
    } catch (errors: any) {
      checkErrorHandler(errors);
    }
  };

  const update = async (values: IUser) => {
    setLoading(true);

    try {
      await UserService.update({ ...data, ...values });

      if (values.password) {
        try {
          await updatePassword(data?.id, values.password);

          checkFinishHandler("updated");
        } catch (errors: any) {
          checkErrorHandler(errors);
        }
      } else {
        checkFinishHandler("updated");
      }
    } catch (errors: any) {
      checkErrorHandler(errors);
    }
  };

  const updatePassword = async (userId: string, password: string) => {
    return UserService.updatePassword(userId, password);
  };

  const checkFinishHandler = (message: string) => {
    notification.success({ message: `User has been ${message}` });

    setLoading(false);

    navigate(`/${PrivateUIRoutes.CONTROL_PANEL}/${PrivateUIRoutes.USERS}`);
  };

  const checkErrorHandler = (errors: any) => {
    setLoading(false);

    CommonService.showAllErrors(errors);
  };

  const handleSubmitForm = async (values: any) => {
    if (!!data?.id) {
      await update(values);
    } else {
      await create(values);
    }
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      hideRequiredMark={false}
      onFinish={handleSubmitForm}
    >
      <Form.Item
        label="Name"
        name="name"
        rules={[{ required: true, message: "Please input username!" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Email"
        name="email"
        rules={[
          { required: true, message: "Please input email!" },
          { type: "email", message: "Invalid email!" },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Password(optional)"
        name="password"
        rules={[{ required: false, message: "Please input password!" }]}
      >
        <Input.Password />
      </Form.Item>
      <Form.Item
        label="Role"
        name="idRole"
        rules={[{ required: true, message: "Please select a role!" }]}
      >
        <Select>
          {CommonService.getNameValues(UserRoleTypes).map((el) => (
            <Select.Option value={el.value} key={el.value}>
              {el.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 5, span: 19 }}>
        <Button type="primary" htmlType="submit" loading={loading}>
          Save changes
        </Button>
      </Form.Item>
    </Form>
  );
};

export default UserForm;
